import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { APP_URL } from '../config';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 197.000000 203.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,203.000000) scale(0.100000,-0.100000)"
        >
          <path d="M938 1673 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
          <path d="M810 1660 c-16 -5 -2 -6 35 -3 33 3 62 7 64 9 8 7 -74 2 -99 -6z" />
          <path
            d="M1038 1659 c284 -48 512 -309 512 -589 0 -36 -7 -93 -15 -128 -15
-64 -66 -175 -86 -187 -6 -4 -68 -9 -137 -11 l-127 -4 29 22 c59 45 115 111
131 157 10 25 21 51 25 56 4 6 6 51 5 100 -1 70 -6 101 -23 140 -57 124 -176
231 -293 261 -82 21 -195 14 -263 -16 -105 -45 -226 -174 -258 -275 -18 -57
-22 -160 -6 -188 6 -13 7 -17 0 -13 -6 4 -8 -2 -5 -14 3 -11 9 -20 14 -20 5 0
9 -9 9 -20 0 -37 61 -112 135 -167 l30 -22 -95 0 c-157 0 -167 4 -206 74 -158
285 -13 656 316 809 30 14 50 25 43 26 -7 0 -50 -19 -95 -42 -198 -101 -337
-322 -338 -534 0 -94 16 -161 61 -254 78 -160 258 -306 419 -341 64 -14 219
-6 296 15 69 18 180 78 230 124 66 60 127 142 162 218 144 315 -28 687 -375
809 -37 14 -86 24 -108 24 -39 -1 -38 -2 13 -10z m-6 -230 c77 -16 105 -33
181 -108 88 -86 110 -146 105 -298 -2 -55 -5 -99 -7 -98 -8 8 -28 -21 -23 -34
3 -8 1 -12 -4 -8 -5 3 -21 -8 -34 -26 -30 -37 -34 -40 -90 -76 -97 -63 -236
-77 -350 -36 -47 16 -151 106 -188 160 -25 38 -41 119 -43 216 -2 89 6 102
109 203 103 100 211 133 344 105z m-422 -739 c0 -5 -4 -10 -10 -10 -5 0 -10 5
-10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m72 -20 c5 -32 -9 -65 -19 -42 -2 6
-13 12 -24 12 -23 0 -24 5 -1 35 23 33 39 31 44 -5z m70 5 c13 -29 -3 -55 -33
-55 -15 0 -19 8 -19 40 0 33 3 40 20 40 12 0 25 -10 32 -25z m67 -17 c11 -32
6 -52 -8 -29 -10 16 -22 16 -32 0 -14 -24 -19 -3 -7 29 16 41 33 41 47 0z m64
25 c-7 -2 -13 -18 -13 -34 0 -16 -4 -29 -10 -29 -5 0 -10 11 -10 25 0 14 -4
25 -10 25 -5 0 -10 5 -10 10 0 6 15 10 33 9 17 0 26 -3 20 -6z m56 -25 c12
-35 8 -46 -12 -30 -10 9 -16 9 -25 0 -18 -18 -23 -5 -10 30 16 41 33 41 47 0z
m57 15 c13 -17 14 -17 8 0 -3 9 -1 17 5 17 6 0 11 -16 11 -35 0 -39 -6 -43
-26 -17 -13 16 -13 16 -14 0 0 -34 -20 -18 -20 17 0 38 15 45 36 18z m93 -15
c11 -32 6 -52 -8 -29 -10 16 -22 16 -32 0 -14 -24 -19 -3 -7 29 16 41 33 41
47 0z m79 -5 c-1 -37 -1 -37 -5 -6 -3 21 -9 30 -17 27 -8 -3 -12 -13 -9 -24 3
-10 0 -21 -6 -24 -7 -4 -11 1 -11 13 0 11 -7 27 -16 35 -14 15 -12 16 25 16
41 0 41 0 39 -37z m71 20 c10 -17 10 -17 11 0 0 9 5 17 11 17 7 0 18 -8 25
-17 13 -17 13 -17 14 0 0 33 20 17 20 -18 0 -41 -21 -47 -38 -12 l-11 22 0
-22 c-1 -27 -21 -31 -21 -5 -1 16 -1 16 -11 0 -11 -20 -44 -24 -54 -7 -4 5 -4
21 -1 35 8 28 40 33 55 7z m-629 -28 c0 -14 -4 -25 -10 -25 -5 0 -10 11 -10
25 0 14 5 25 10 25 6 0 10 -11 10 -25z m427 -109 c14 -14 -12 -20 -80 -21 -40
0 -81 4 -92 9 -18 8 -16 10 15 17 38 8 148 5 157 -5z"
          />
          <path
            d="M919 1341 c-20 -11 -39 -28 -43 -38 -5 -16 -5 -16 6 -2 21 26 74 49
113 49 40 0 68 -12 103 -43 12 -11 22 -16 22 -9 0 6 -14 21 -32 33 -43 31
-121 36 -169 10z"
          />
          <path
            d="M1002 1311 c26 -4 55 -13 65 -21 11 -8 8 -5 -5 8 -17 16 -34 22 -65
21 l-42 -2 47 -6z"
          />
          <path
            d="M919 1289 c-23 -19 -23 -20 -2 -10 12 6 25 16 28 21 10 16 -1 12 -26
-11z"
          />
          <path d="M968 1273 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M1008 1273 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
          <path
            d="M974 1245 c-13 -10 -48 -14 -116 -15 -80 0 -98 -3 -98 -15 0 -10 11
-15 35 -15 l35 0 0 -155 0 -155 -35 0 c-28 0 -35 -4 -35 -20 0 -19 7 -20 100
-20 93 0 100 1 100 20 0 17 -7 20 -38 20 -43 0 -53 6 -45 26 4 11 27 14 94 14
l89 0 0 -40 c0 -36 3 -40 25 -40 23 0 25 4 25 40 0 36 3 40 25 40 16 0 25 6
25 15 0 9 -9 15 -25 15 -24 0 -25 2 -25 70 0 67 -1 70 -24 70 -22 0 -23 -4
-25 -67 -1 -37 -3 -69 -5 -70 -2 -2 -43 -3 -92 -1 l-89 3 38 19 c52 26 122
107 141 163 21 61 20 73 -4 73 -11 0 -20 4 -20 10 0 20 -37 30 -56 15z m34
-56 c28 -1 27 -3 -6 -64 -24 -44 -108 -123 -119 -111 -4 3 -7 134 -4 174 1 11
13 13 54 8 28 -3 62 -7 75 -7z"
          />
          <path
            d="M645 660 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
          />
          <path
            d="M720 660 c0 -11 5 -20 10 -20 6 0 10 9 10 20 0 11 -4 20 -10 20 -5 0
-10 -9 -10 -20z"
          />
          <path d="M1200 654 c0 -17 22 -14 28 4 2 7 -3 12 -12 12 -9 0 -16 -7 -16 -16z" />
          <path
            d="M870 1579 c0 -22 5 -29 20 -29 14 0 20 7 20 24 0 15 -7 26 -20 29
-17 4 -20 0 -20 -24z m30 -4 c0 -8 -4 -15 -10 -15 -5 0 -10 7 -10 15 0 8 5 15
10 15 6 0 10 -7 10 -15z"
          />
          <path d="M932 1580 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" />
          <path
            d="M1036 1585 c-4 -14 -4 -30 -1 -35 8 -13 42 -8 42 7 0 6 -4 10 -9 7
-5 -3 -6 6 -2 20 4 19 2 26 -9 26 -8 0 -18 -11 -21 -25z m19 -25 c3 -5 1 -10
-4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z"
          />
          <path
            d="M954 1585 c-7 -18 3 -35 22 -35 13 0 13 3 -2 17 -15 16 -15 17 2 24
17 7 18 8 1 8 -10 1 -20 -6 -23 -14z"
          />
          <path
            d="M756 1570 c3 -14 11 -32 16 -40 6 -10 7 -7 2 10 -3 14 -11 32 -16 40
-6 10 -7 7 -2 -10z"
          />
          <path
            d="M828 1581 c11 -6 10 -10 -4 -15 -13 -5 -14 -10 -6 -18 6 -6 17 -8 26
-5 19 8 9 47 -13 47 -12 0 -13 -2 -3 -9z"
          />
          <path
            d="M1120 1571 c0 -5 -3 -18 -7 -28 -6 -15 -4 -16 9 -6 8 7 19 9 24 5 4
-4 3 0 -4 10 -11 14 -10 17 5 21 14 4 13 5 -4 6 -13 0 -23 -3 -23 -8z"
          />
          <path d="M792 1550 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
          <path d="M720 1536 c0 -22 17 -28 24 -10 9 22 8 24 -9 24 -8 0 -15 -6 -15 -14z" />
          <path
            d="M1170 1541 c13 -9 12 -11 -3 -11 -11 0 -17 -6 -14 -12 2 -7 10 -13
18 -13 19 0 18 37 -1 42 -13 4 -13 3 0 -6z"
          />
          <path
            d="M665 1530 c-3 -5 -1 -19 6 -31 8 -16 13 -18 19 -9 4 7 13 9 19 6 8
-5 8 0 -1 18 -11 26 -32 34 -43 16z m25 -10 c0 -5 -4 -10 -10 -10 -5 0 -10 5
-10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z"
          />
          <path
            d="M1204 1504 c3 -9 6 -18 6 -20 0 -2 4 -4 8 -4 4 0 8 9 8 20 0 11 -7
20 -14 20 -9 0 -12 -6 -8 -16z"
          />
          <path
            d="M1247 1490 c-9 -13 -13 -28 -10 -34 4 -6 8 -4 11 4 3 8 9 18 15 21 5
4 7 13 5 20 -3 8 -10 5 -21 -11z"
          />
          <path
            d="M593 1465 c0 -8 6 -15 14 -15 7 0 13 -7 13 -15 0 -17 -11 -19 -28 -5
-7 5 -5 2 3 -7 13 -15 17 -16 30 -2 14 14 13 17 -8 37 -18 17 -24 19 -24 7z"
          />
          <path
            d="M1305 1459 c-4 -5 -3 -19 1 -32 6 -20 5 -21 -11 -7 -16 13 -18 13
-13 0 8 -24 33 -18 32 8 0 15 4 21 13 18 7 -3 13 -1 13 3 0 13 -29 22 -35 10z"
          />
          <path
            d="M557 1413 c-4 -3 -7 -12 -7 -20 0 -15 36 -18 45 -3 3 5 0 7 -8 4 -8
-3 -18 0 -23 7 -4 8 -3 10 4 5 7 -4 12 -2 12 3 0 12 -13 14 -23 4z"
          />
          <path
            d="M1323 1394 c-3 -8 -1 -20 5 -26 7 -7 10 -5 9 7 -1 10 5 20 13 22 12
4 12 3 1 -5 -8 -6 -9 -12 -3 -16 13 -8 26 10 17 24 -9 15 -35 12 -42 -6z"
          />
          <path
            d="M530 1355 c7 -8 17 -15 22 -15 6 0 5 7 -2 15 -7 8 -17 15 -22 15 -6
0 -5 -7 2 -15z"
          />
          <path
            d="M1361 1356 c-9 -11 -6 -12 14 -8 14 2 22 8 19 13 -8 13 -20 11 -33
-5z"
          />
          <path d="M500 1341 c0 -10 30 -24 37 -17 3 2 -5 9 -16 16 -12 6 -21 7 -21 1z" />
          <path
            d="M1392 1328 c-19 -19 -14 -28 16 -27 15 1 20 3 10 6 -10 2 -15 10 -11
19 6 17 1 18 -15 2z"
          />
          <path
            d="M490 1314 c0 -2 9 -8 20 -14 11 -6 20 -7 20 -2 0 6 -9 12 -20 15 -11
3 -20 3 -20 1z"
          />
          <path
            d="M1424 1287 c-16 -9 -19 -18 -13 -37 5 -18 7 -20 8 -6 1 12 6 16 16
12 8 -3 15 -1 15 4 0 6 -8 10 -17 10 -15 0 -14 2 3 15 23 17 17 19 -12 2z"
          />
          <path
            d="M470 1282 c0 -18 29 -27 43 -13 9 9 8 11 -7 5 -11 -4 -21 -2 -27 7
-6 10 -9 11 -9 1z"
          />
          <path
            d="M466 1235 c19 -15 19 -15 -1 -9 -16 6 -18 5 -7 -7 10 -11 15 -10 30
5 9 11 11 16 5 12 -7 -4 -13 -2 -13 3 0 6 -8 11 -17 11 -15 0 -14 -2 3 -15z"
          />
          <path
            d="M1423 1215 c-3 -9 -3 -19 1 -22 3 -4 6 0 6 8 0 12 2 11 10 -1 7 -11
12 -12 21 -3 6 6 8 16 5 22 -10 16 -36 13 -43 -4z"
          />
          <path
            d="M419 1200 c-14 -37 13 -53 38 -22 13 16 14 15 10 -6 -3 -12 -1 -20 4
-16 14 8 10 44 -5 44 -8 0 -17 -8 -21 -17 -7 -15 -9 -14 -14 7 -5 18 -9 21
-12 10z"
          />
          <path d="M416 1054 c-3 -8 3 -12 15 -11 10 1 19 6 19 12 0 16 -28 15 -34 -1z" />
          <path
            d="M1447 1055 c-3 -6 4 -11 14 -11 11 0 19 5 19 11 0 7 -7 12 -15 12 -8
0 -16 -5 -18 -12z"
          />
          <path
            d="M1353 846 c-13 -6 -23 -14 -23 -18 0 -3 -6 -13 -12 -20 -7 -8 -22
-24 -33 -37 l-19 -22 29 7 c36 8 62 30 81 66 16 31 9 39 -23 24z"
          />
          <path
            d="M575 770 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 -8 0
-12 -4 -9 -10z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  // Render as external link
  return (
    <a
      href={APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      {logo}
    </a>
  );
}
